export default __webpack_public_path__ + "static/media/mountains.c0fc6e24.webp";